import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import * as VeeValidate from 'vee-validate';

const config = {
    errorBagName: 'errors', // change if property conflicts
    fieldsBagName: 'fields',
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true,
    classes: true,
    classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'invalid', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true,
    validity: true,
    aria: true
};

Vue.use(VeeValidate, config);

var login = new Vue({
    el: '#login',
    created: function () {
        document.getElementById("spinner").className = "noDisplay";
    },
    data: {
        user: {
            //EmailAddress ,
            //Password ,
            //RememberMe: false,
            //ErrorMessage: ""
        },
        hasErrors: false,
        isLoading: false,
        modelState: [


        ]

    },

    methods: {
        handlesubmit: function (event) {
            var that = this;
            that.$validator.validateAll().then(function (result) {
                if (result) {
                    // eslint-disable-next-line

                    that.$data.modelState = [];
                    var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
                    that.$data.isLoading = true;
                    that.b64EncodeUnicode();
                    document.getElementById("spinner").className = "loader";
                    axios.post("/Account/Login?returnUrl=" + window.returnURL, that.$data.user, {
                        headers: { "RequestVerificationToken": antiForgeryToken }
                    }).then(function (response) {
          
                        that.$data.isLoading = false;

                        if (window.returnURL == "/" || window.returnURL.indexOf("Account") !== -1 || window.returnURL == "") {
                            //window.returnURL = window.ServerUrl;
                            window.returnURL = "/";
                        }
                        if (response.data.result == 'error') {
                            that.processModelState(JSON.parse(response.data.errors), that);
                            //that.$data.modelState = JSON.parse(response.data.errors);

                        }
                        //that.processModelState(response.data.responseJSON, that);
                        else
                            window.location.href = window.returnURL;


                        document.getElementById("spinner").className = "noDisplay";
                    })
                        .catch(function (error) {
                            that.$data.isLoading = false;
                            var status = error.response.status;
                            //document.getElementById("overlay").style.display = "none";
                            if (error.response && status == 409) {
                                var test = error.response.status;
                                that.$data.modelState.push({ Key: 'password' , Value: error.response.data });
                            }

                            document.getElementById("spinner").className = "noDisplay";

                        });



                }

                //alert('Correct them errors!');
            });

        },
        b64EncodeUnicode: function () {
            var that = this;
            // first we use encodeURIComponent to get percent-encoded UTF-8,
            // then we convert the percent encodings into raw bytes which
            // can be fed into btoa.
            that.$data.user.Password = btoa(encodeURIComponent(that.$data.user.Password.trim()).replace(/%([0-9A-F]{2})/g,
                function toSolidBytes(match, p1) {
                    return String.fromCharCode('0x' + p1);
                }));
        },
        processModelState: function (response, vm) {
            if (response) {
                $.each(response, function (i, state) {
                    var message = "";
                    var stateErrors = state.Value;
                    if (stateErrors) {
                        $.each(stateErrors, function (j, stateError) {
                            if (j > 0) {
                                message += "; ";
                            }
                            message += stateError;
                        });

                        vm.$data.modelState.push({ Key: state.Key, Value: message });
                    }
                });
            }
        }
    }

})